import { Routes, Route, Navigate } from 'react-router-dom';
import { LiveMonitoringPage } from './LiveMonitoringPage';
import { BatchesListPage } from './BatchesListPage';
import { BatchUploadPage } from './BatchUploadPage';
import { BatchDetailPage } from './BatchDetailPage';
import { ReassignPage } from './ReassignPage';
import { AuditLogPage } from './AuditLogPage';
import { TeamPage } from './TeamPage';
import MissedBookingsPage from './MissedBookingsPage';
import { MyProfilePage } from './MyProfilePage';
import { SettingsPage as AdminSettingsPage } from './SettingsPage';
import { BugReportsPage } from './BugReportsPage';
import { UploaderTeamPage } from './UploaderTeamPage';
import { ReportsPage } from './ReportsPage';
import { UploadersActivityPage } from './UploadersActivityPage';
import AgentsProgressPage from './AgentsProgressPage';
import { SystemConfigPage } from './SystemConfigPage';
import { NavigationAdminPage } from './NavigationAdminPage';
// F5-T8 (contrato Supervisor): cableado mínimo — la entrada vive en AdminChrome.
import { PreauthorizationsPage } from './PreauthorizationsPage';
// F5-R6c (Admin 14 «Chat y notificaciones»): ventana NUEVA del grupo de
// Configuración — su entrada vive en AdminChrome (grupo Sistema, solo admin).
import { ChatNotificationsPage } from './ChatNotificationsPage';
import { AdminChrome } from './components/AdminChrome';
import { ChatPanel } from '@/features/chat/ChatPanel';
import { useHeartbeat } from '@/features/heartbeat/useHeartbeat';
import { useAuthStore, selectIsAuthenticated } from '@/stores/auth.store';
import { useT } from '@/i18n';

/**
 * F5-T3 (mockup «Admin 01 — Cáscara y sidebar»): el admin gana su PROPIO
 * chrome, como navigator y uploader — ya no vive dentro del AppShell del
 * agente. Lo que el AppShell aportaba y el admin sigue necesitando viaja
 * acá: heartbeat de presencia, el panel de chat, el skip-link y el pie
 * HIPAA. Las rutas no cambian.
 */
export default function AdminShell(): JSX.Element {
  const t = useT();
  const isAuth = useAuthStore(selectIsAuthenticated);
  useHeartbeat({ enabled: isAuth });

  return (
    <>
      <a href="#main" className="skip-link">{t('appshell.skipLink')}</a>
      <AdminChrome>
        <main id="main" className="min-w-0">
          <Routes>
            <Route index element={<LiveMonitoringPage />} />
            <Route path="batches" element={<BatchesListPage />} />
            <Route path="batches/upload" element={<BatchUploadPage />} />
            <Route path="batches/:id" element={<BatchDetailPage />} />
            <Route path="reassign" element={<ReassignPage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="audit" element={<AuditLogPage />} />
            <Route path="missed-bookings" element={<MissedBookingsPage />} />
            <Route path="preauthorizations" element={<PreauthorizationsPage />} />
            <Route path="profile" element={<MyProfilePage />} />
            <Route path="settings" element={<AdminSettingsPage />} />
            <Route path="chat-notifications" element={<ChatNotificationsPage />} />
            <Route path="bug-reports" element={<BugReportsPage />} />
            <Route path="uploader-team" element={<UploaderTeamPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="uploaders-activity" element={<UploadersActivityPage />} />
            <Route path="agents-progress" element={<AgentsProgressPage />} />
            <Route path="system-config" element={<SystemConfigPage />} />
            <Route path="navigation" element={<NavigationAdminPage />} />
            <Route path="*" element={<Navigate to="" replace />} />
          </Routes>
        </main>
        <footer className="text-center text-xs text-nav-slate pt-6 pb-2">
          {t('appshell.footer')}
        </footer>
      </AdminChrome>
      <ChatPanel />
    </>
  );
}
